import React from 'react';
import cn from 'classnames';
import { SIZE_TO_CLASSNAME_MAP } from '../../consts.js';

var styles = {"optgroup":"select__optgroup_1dppw","label":"select__label_1dppw","size-64":"select__size-64_1dppw","size-72":"select__size-72_1dppw"};
require('./index.css')

var Optgroup = function (_a) {
    var children = _a.children, className = _a.className, label = _a.label, _b = _a.size, size = _b === void 0 ? 48 : _b;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cn(styles.optgroup, className, styles[SIZE_TO_CLASSNAME_MAP[size]]) },
            React.createElement("span", { className: styles.label }, label)),
        children));
};

export { Optgroup };
